import React from 'react';

interface Props {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
}

export default function Header({ title, description }: Props) {
  return (
    <>
      <h2 className="text-center text-2xl font-bold text-green-primary-text">{title}</h2>
      {description ? (
        <p className="!mt-0 pt-2 text-center text-sm font-light leading-6 text-brown-dark">{description}</p>
      ) : null}
    </>
  );
}
